import {
    Injectable,
    Injector,
    InputSignal,
    Signal,
    computed,
    effect,
    WritableSignal,
    signal,
    untracked,
} from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';
// Move these into this library and recreate it
// EYEQ-7385
// import {
//     DatiqInputValidatorMaxService,
//     DatiqInputValidatorMaxlengthService,
//     DatiqInputValidatorMinService,
//     DatiqInputValidatorMinlengthService,
//     DatiqInputValidatorPatternService,
//     DatiqInputValidatorPercentmaxService,
//     DatiqInputValidatorPercentminService,
// } from '@dat/datiq-components-pkg/input';
// import {
//     DatiqInputErrorTypes,
//     DatiqInputService,
//     DatiqInputValidatorRequiredService,
//     DatiqValidatorsRegisterService,
//     IDatiqInput,
//     emptyDatiqInput,
// } from '@dat/datiq-components-pkg/utils';
import { IIqControlTextStateService } from '../../models';
import { toSignal } from '@angular/core/rxjs-interop';
import { isEmpty } from 'lodash';
import { IDatiqGeoSuggestion, IqProxyGeoService } from '@dat/iq-proxy';
@Injectable({
    providedIn: 'root',
})
export class IqControlTextStateService implements IIqControlTextStateService {
    constructor(
        // private readonly _validatorRegistry: DatiqValidatorsRegisterService,
        // private readonly _max: DatiqInputValidatorMaxService,
        // private readonly _maxlength: DatiqInputValidatorMaxlengthService,
        // private readonly _min: DatiqInputValidatorMinService,
        // private readonly _minlength: DatiqInputValidatorMinlengthService,
        // private readonly _pattern: DatiqInputValidatorPatternService,
        // private readonly _percentmax: DatiqInputValidatorPercentmaxService,
        // private readonly _percentmin: DatiqInputValidatorPercentminService,
        // private readonly _required: DatiqInputValidatorRequiredService,
        private readonly _fb: FormBuilder,
        private readonly _geo: IqProxyGeoService,
        private readonly _injector: Injector, // private readonly _input: DatiqInputService,
    ) {
        // this._validatorRegistry.register(DatiqInputErrorTypes.Max, this._max);
        // this._validatorRegistry.register(
        //     DatiqInputErrorTypes.MaxLength,
        //     this._maxlength,
        // );
        // this._validatorRegistry.register(DatiqInputErrorTypes.Min, this._min);
        // this._validatorRegistry.register(
        //     DatiqInputErrorTypes.MinLength,
        //     this._minlength,
        // );
        // this._validatorRegistry.register(
        //     DatiqInputErrorTypes.Pattern,
        //     this._pattern,
        // );
        // this._validatorRegistry.register(
        //     DatiqInputErrorTypes.PercentMax,
        //     this._percentmax,
        // );
        // this._validatorRegistry.register(
        //     DatiqInputErrorTypes.PercentMin,
        //     this._percentmin,
        // );
        // this._validatorRegistry.register(
        //     DatiqInputErrorTypes.Required,
        //     this._required,
        // );
    }

    integer(
        name: InputSignal<string>,
        value: InputSignal<number>,
        fg: FormGroup<any> = new FormGroup({}),
        {
            disabled,
            minValue,
            maxValue,
            required,
        }: {
            disabled: InputSignal<boolean>;
            minValue: InputSignal<number>;
            maxValue: InputSignal<number>;
            required: InputSignal<boolean>;
        },
    ): Signal<number> {
        fg.addControl(
            name(),
            this._fb.control(
                value(),
                // this._input.createControlValidation(
                //     {
                //         ...emptyDatiqInput,
                //         required: required(),
                //         min: minValue(),
                //         max: maxValue(),
                //     },
                //     fg,
                // ),
            ),
        );
        const formControl: AbstractControl = fg.get(name());
        const control: Signal<number> = toSignal(formControl?.valueChanges, {
            injector: this._injector,
        });

        effect(
            () => {
                const currentValue = value();
                untracked(() => {
                    formControl.setValue(currentValue);
                });
            },
            { injector: this._injector },
        );
        effect(
            () => {
                const isDisabled = disabled();
                untracked(() => {
                    formControl[isDisabled ? 'disable' : 'enable']();
                });
            },
            { injector: this._injector },
        );

        return computed(() => {
            return control();
        });
    }

    percent(
        name: InputSignal<string>,
        value: InputSignal<number>,
        fg: FormGroup<any>,
        {
            disabled,
            minValue,
            maxValue,
            required,
        }: {
            disabled: InputSignal<boolean>;
            minValue: InputSignal<number>;
            maxValue: InputSignal<number>;
            required: InputSignal<boolean>;
        },
    ): Signal<number> {
        if (isEmpty(fg)) return signal(0);

        fg.addControl(
            name(),
            this._fb.control(
                value(),
                // this._input.createControlValidation(
                //     {
                //         ...emptyDatiqInput,
                //         required: required(),
                //         percentmin: minValue() * 100 ?? 0,
                //         percentmax: maxValue() * 100 ?? 100,
                //     },
                //     fg,
                // ),
            ),
        );
        const formControl: AbstractControl = fg?.get(name());
        const control: Signal<number> = toSignal(formControl?.valueChanges, {
            injector: this._injector,
        });

        effect(
            () => {
                const currentValue = value();
                untracked(() => {
                    formControl.setValue((currentValue ?? 0) * 100);
                });
            },
            { injector: this._injector },
        );
        effect(
            () => {
                const isDisabled = disabled();
                untracked(() => {
                    formControl[isDisabled ? 'disable' : 'enable']();
                });
            },
            { injector: this._injector },
        );

        return computed(() => {
            return control();
        });
    }

    fetchGeoSuggestions(query: string): Promise<IDatiqGeoSuggestion[]> {
        return this._geo.fetchSuggestions(query);
    }

    geoSuggestions(
        queryValue: Signal<string>,
    ): Signal<Promise<IDatiqGeoSuggestion[]>> {
        return computed((): Promise<IDatiqGeoSuggestion[]> => {
            const currentQuery = queryValue();

            if (currentQuery?.length < 3) return Promise.resolve([]);

            return this._geo.fetchSuggestions(currentQuery);
        });
    }

    currency(
        name: InputSignal<string>,
        value: InputSignal<number>,
        fg: FormGroup<{}>,
        {
            disabled,
            minValue,
            maxValue,
            required,
        }: {
            disabled: InputSignal<boolean>;
            minValue: InputSignal<number>;
            maxValue: InputSignal<number>;
            required: InputSignal<boolean>;
        },
    ): Signal<number> {
        if (isEmpty(fg)) return signal(0);

        fg.addControl(
            name(),
            this._fb.control(
                value(),
                // this._input.createControlValidation(
                //     {
                //         ...emptyDatiqInput,
                //         required: required(),
                //         min: minValue(),
                //         max: maxValue(),
                //     },
                //     fg,
                // ),
            ),
        );
        const formControl: AbstractControl = fg?.get(name());
        const control: Signal<number> = toSignal(formControl?.valueChanges, {
            injector: this._injector,
        });

        effect(
            () => {
                const currentValue = value();
                untracked(() => {
                    formControl.setValue(currentValue ?? 0);
                });
            },
            { injector: this._injector },
        );
        effect(
            () => {
                const isDisabled = disabled();
                untracked(() => {
                    formControl[isDisabled ? 'disable' : 'enable']();
                });
            },
            { injector: this._injector },
        );

        return computed(() => {
            return control();
        });
    }

    errorMessage(inputControl: FormControl): Signal<string> {
        if (!inputControl) return signal('');

        // const errorMessages = this._input.getErrorMessagesFromSettings({
        //     ...emptyDatiqInput,
        // });
        const status: Signal<string> = toSignal(inputControl?.statusChanges, {
            injector: this._injector,
        });

        return computed(() => {
            if (status() === 'VALID') return '';

            return inputControl.pristine
                ? ''
                : // : this._input.getErrorMessage(inputControl, {});
                  '';
        });
    }

    geoRequired(required: boolean): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return !!control?.value?.length
                ? null
                : { required: required };
        };
    }

    getErrorMessage(inputControl: FormControl): string {
            return 'Error';
        // const errorMessages = this._input.getErrorMessagesFromSettings(
        //     {} as IDatiqInput,
        // );
        // return this._input.getErrorMessage(
        //     inputControl,
        //     errorMessages
        // );
    }
}
